import { Button, Dropdown, Icon, Input, Menu, Modal, Popover, Select, Spin, Table } from "antd"
import "./dataModel.css"
import React, { useCallback, useEffect, useRef, useState } from "react"
import Style from '../acl/acl.module.sass';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search-icon.svg'
import { ReactComponent as Dot } from '../../../assets/svg/dotIcon.svg'
import { SortOrder } from 'antd/lib/table/interface';
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Http } from '../../../helpers/axois';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import { ReactComponent as Tick } from '../../../assets/svg/tick_data.svg';
import { ReactComponent as Cross } from '../../../assets/svg/cross_icon.svg';
import { ReactComponent as CloseButton } from '../../../assets/svg/close_btn_rounded.svg';
import { useToast } from "../../../helpers/commonFunction";
import { ReactComponent as NOData } from '../../../assets/svg/no-data-model.svg';
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg';
import { debounce } from "lodash";
import NoData from '../../apps/NoData'
import { highlightMatch } from "../../../helpers/SearchBar";

const { Option } = Select;

export const DataModel = () => {
    const menu = ["Boolean","Date", "Integer", "String"]
    const [addNew, setAddNew] = useState<boolean>(false);
    const [columnName, setColumnName] = useState<string>("");
    const [bindParam, setBindParam] = useState<string>("");
    const [valType, setValType] = useState<string>("")
    const [apiResponse, setApiResponse] = useState<any[]>([]);
    const [deleteKey, setDeleteKey] = useState<string>("");
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [searchValue, setSearchValue] = useState<string>("");
    const [inputValue, setInputValue] = useState<string>("");
    const [filteredData, setFilteredData] = useState<any>([])
    const { ErrorToast, SuccessToast } = useToast();
    const [hoveredRow, setHoveredRow] = useState<any>(null);
    const [deleteColumnName, setDeleteColumnName] = useState<any>("");
    const token = localStorage.getItem("studioToken");
    const [isLoading, setIsLoading] = useState(false);
    const params: { appId?: string } = useParams();
    const appId: any = params.appId;
    const versionId = useSelector((state: any) => {
        return appId && state.apps.appVersion[appId].versionId
    });
    const selectedBranch = useSelector((state: any) => state.apps.appBranch);
    const currentBranchId = appId && selectedBranch && selectedBranch[appId] && selectedBranch[appId].branchId;

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const appPermissions: any = useSelector((state: any) => {
        return state.apps.selectedApp.permissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const appVersion = useSelector((state: any) => state.apps.appVersion && state.apps.appVersion[appId]);
    const currentVersion = appVersion && appVersion.currentVersion;
    const canCreateDM = currentVersion && (orgPermissions.includes('dataModel.Create') || appPermissions.includes('dataModel.Create'))
    const canDeleteDM = currentVersion && (orgPermissions.includes('dataModel.Delete') || appPermissions.includes('dataModel.Delete'))
    const canViewDM = orgPermissions.includes('dataModel.View') || appPermissions.includes('dataModel.View')

    useEffect(()=>{
        if(appId && versionId && currentBranchId){
            getData();
        }
    },[versionId, appId]);

    const getData = () => {
        setIsLoading(true)
        setApiResponse([])
        setFilteredData([])
        Http.get(`/apps/${appId}/dataModel?versionId=${versionId}&branchId=${currentBranchId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }).subscribe((res: any) => {
            batchUpdateState(res)
            setIsLoading(false)
        });
    };

    // Debounced function to update search value
     const updateSearchValue = useCallback(
        debounce((val) => {
            setSearchValue(val);
        }, 500),
        []
    );

    const handleChange = (e: any) => {
        const val = e.target.value.replace(/[^a-zA-Z0-9_]/g, ''); // Allow only alphanumeric and underscore
        setInputValue(val);
        updateSearchValue(val);
    };

    const onFilter = () => {
        let filteredResult = apiResponse;
        if (searchValue) {
            const regex = new RegExp(searchValue, 'i');
            filteredResult = apiResponse.filter((item) => regex.test(item.cName + item.bind + item.cType));
        }
        setFilteredData(filteredResult);
    }
    
    const clearFilter = () => {
        setFilteredData(apiResponse);
    }

    useEffect(() => {
        if (searchValue.length > 0) {
            onFilter();
        } else {
            clearFilter();
        }
    }, [searchValue])

    useEffect(() => {
        if (deleteModalVisible) {
            let deleteName = apiResponse
                .filter((data) => data.dataModelId === deleteKey)
                .map((data) => data.cName);
            setDeleteColumnName(deleteName)
        }
    }, [deleteModalVisible])
    

    let newData = [{
        cName: "",
        cType: "",
        bind: ""
    }]

    const createNewData = () => {
        const data = {
            cName: columnName,
            cType: valType,
            bind: bindParam,
            branchId: currentBranchId
        }

        const isDuplicate = (apiResponse && apiResponse.some((res: any) => (res.bind == data.bind || res.name == data.cName)))

        if (isDuplicate) {
            ErrorToast("Data already exists")
            setAddNew(true)
        } else {
            setIsLoading(true);
            Http.post(`/apps/${appId}/dataModel?versionId=${versionId}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }).subscribe(
                (res: any) => {
                    SuccessToast('Data added successfully');
                    getData();
                    clearValues();
                    setAddNew(false);
                },
                (err: any) => {
                    setAddNew(true);
                    setIsLoading(false);
                    ErrorToast(err.message);
                }
            );
        }
    }

    const clearValues = () => {
        setColumnName("")
        setBindParam("")
        setValType("")
    }

    const removeRecord = (deleteKey: string) => {
        let response = apiResponse.filter((data) => data.dataModelId != deleteKey)
        setApiResponse(response)
        setFilteredData(response)
    }

    const deleteData = () => {
        setIsLoading(true);
        Http.delete(`/apps/${appId}/dataModel/${deleteKey}?versionId=${versionId}&branchId=${currentBranchId}`,{
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }).subscribe((res: any) => {
            SuccessToast("deleted successfully")
            removeRecord(deleteKey)
        }, (err) => {
            setIsLoading(false);
            ErrorToast(err)
        })
        setDeleteModalVisible(false)
        clearValues()
    }

    const getColorForType = (type: string) => {
        const val = type?.toLowerCase()
        switch (val) {
            case "integer":
                return "#00B273";
            case "boolean":
                return "#D85900";
            case "string":
                return "#0052B3";
            case "date":
                return "#DDAA00";
            default:
                return "#FFFFFF";
        }
    }

    const getBackgroundColorForType = (type: string) => {
        const val = type?.toLowerCase()
        switch (val) {
            case "integer":
                return "#EDFFF9";
            case "boolean":
                return "#FFF6EF";
            case "string":
                return "#EDF6FF";
            case "date":
                return "#FFFBEF";
            default:
                return "#292D32";
        }
    }

    const verifyRecord = () => {
        const regex = /^[a-zA-Z][a-zA-Z0-9_]*$/;
        if (columnName.trim() === "" || bindParam.trim() === "" || valType.trim() === "") {
            ErrorToast("All 3 fields should be filled");
        } else if (columnName.length > 100 || bindParam.length > 100) {
            ErrorToast("Column Name and Bind Params should not exceed 100 characters");
        } else if (!regex.test(bindParam)) {
            ErrorToast("Bind Params must contain only letters, numbers, or underscores");
        } else {
            createNewData();
            return;
        }
        setAddNew(true);
    };

    const batchUpdateState = (data: any) => {
        let batchSize = 100;
    
        const processBatch = (index: any) => {
            if (index >= data.length) return;
    
            setApiResponse((prev) => [...prev, ...data.slice(index, index + batchSize)]);
            setFilteredData((prev: any) => [...prev, ...data.slice(index, index + batchSize)]);
    
            requestIdleCallback((deadline) => {
                // runs even if idle time never comes (after timeout)
                processBatch(index + batchSize)
            }, { timeout: 4000 });
        };
    
        processBatch(0);
    };


    let columns = [
        {
            key: 'cName',
            title: 'Column Name',
            dataIndex: 'cName',
            width: '35%',
            sorter: (a: any, b: any) => a?.cName.localeCompare(b?.cName),
            sortDirections: ['ascend' as SortOrder, 'descend' as SortOrder],
            render: (record: any, index: any) => {
                const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === 'Enter') {
                        verifyRecord()
                    }
                };

                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: "center", fontWeight: 600, fontSize: 13, color: "#292D32", paddingRight: 30 }}
                        onKeyDown={handleKeyDown}>
                        {
                            addNew ? (
                                record && record !== "" ? (
                                    <span className="truncated-text" title={record}>
                                        {highlightMatch(record, searchValue)}
                                    </span>
                                ) : (
                                    <Input
                                        placeholder="Enter column name"
                                        style={{ width: 365, height: 36, border: "1px solid #95ABD3", borderRadius: 4 }}
                                        onChange={(e) => setColumnName(e.target.value)}
                                    />
                                )
                            ) : (
                                <span className="truncated-text" title={record}>
                                    {highlightMatch(record, searchValue)}
                                </span>
                            )
                        }
                    </div>
                )
            },
        },
        {
            key: 'cType',
            title: 'Type',
            dataIndex: 'cType',
            width: '19%',
            sorter: (a: any, b: any) => a.cType.localeCompare(b.cType),
            sortDirections: ['ascend' as SortOrder, 'descend' as SortOrder],
            render: (record: any, index: any) => {
                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: "center", fontWeight: 600, fontSize: 13, color: "#292D32" }}>
                        {
                            addNew ? (
                                record && record !== "" ?
                                    <div style={{ display: "flex", alignItems: "left", justifyContent: "flex-start", color: getColorForType(record), backgroundColor: getBackgroundColorForType(record), padding: '4px 6px', borderRadius: 6, width: 70, height: 20 }} >
                                        <span style={{ paddingRight: 4 }}><Dot fill={getColorForType(record)}></Dot></span>
                                        <span style={{fontSize: 11, fontWeight: 400}}>{highlightMatch(record, searchValue)}</span>
                                    </div> :
                                    <Select className="dm-select-type" defaultValue="Select type" style={{ width: 145, border: "1px solid #95ABD3", borderRadius: 4, height: 36, color: valType ? "#292D32" : "#9D9D9D", fontSize: valType ? 13 :14, fontWeight: 400  }} onChange={(val) => setValType(val)}>
                                        {menu.map((item: any) => (
                                            <Option key={item} value={item}>{item}</Option>
                                        ))}
                                    </Select>
                            ) : <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", color: getColorForType(record), backgroundColor: getBackgroundColorForType(record), padding: '3px 6px', borderRadius: 6, width: 70, height: 20 }} >
                                <span style={{marginRight: 4, display: "flex", justifyContent: "center" }}><Dot fill={getColorForType(record)}></Dot></span>
                                <span style={{fontSize: 11, fontWeight: 400}}>{highlightMatch(record, searchValue)}</span>
                            </div>
                        }
                    </div>
                )
            },
        },
        {
            key: 'bind',
            title: 'Bind Params',
            dataIndex: 'bind',
            width: '55%',
            sorter: (a: any, b: any) => a.bind.localeCompare(b.bind),
            sortDirections: ['ascend' as SortOrder, 'descend' as SortOrder],
            render: (record: any, index: any) => {
                const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === 'Enter') {
                        verifyRecord()
                    }
                };

                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: "center", fontWeight: 600, fontSize: 13, color: "#292D32", paddingRight: 10 }}
                        onKeyDown={handleKeyDown}>
                        {
                            addNew ?
                                record && record !== "" ? (
                                    <span className="truncated-text" title={record}>
                                        {highlightMatch(record, searchValue)}
                                    </span>
                                ) : (
                                    <Input 
                                        placeholder="Enter bind params"
                                        style={{ maxWidth: 600, height: 36, border: "1px solid #95ABD3", borderRadius: 4 }}
                                        onChange={(e) => setBindParam(e.target.value)} />)
                                : 
                                <div className="truncated-text" title={record}>
                                    {highlightMatch(record, searchValue)}
                                </div>
                        }
                    </div>
                )
            },
        },
        {
            key: 'action',
            dataIndex: 'dataModelId',
            width: '15%',
            render: (record: any, index: any) => {
                const createDeleteButton = () => (
                    canDeleteDM &&
                    <Delete
                        style={{ width: '15px', height: '15px', marginLeft: '9px', visibility: hoveredRow?.dataModelId === record ? 'visible' : 'hidden' }}
                        title="Delete"
                        onClick={() => {
                            setDeleteKey(record);
                            setDeleteModalVisible(true);
                        }}
                    />
                );

                const createActionButtons = () => (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Tick
                            style={{ marginRight: 8 }}
                            title="Confirm"
                            onClick={() => {
                                verifyRecord()
                            }}
                        />
                        <Cross title="Discard" style={{width: 20, height: 20}} onClick={() => { setAddNew(false)}}></Cross>
                    </div>
                );

                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        {addNew ?
                            (typeof record !== "undefined" && record !== "") ? createDeleteButton() : createActionButtons()
                            :
                            createDeleteButton()
                        }

                    </div>
                );
            },
        }
    ]

    return (
        <>
            {canViewDM ?
                <div className='viewWrapper data-model' style={{ fontFamily: "Mulish" }}>
                    <div className={Style.content} style={{ padding: "0px 20px" }}>
                        <div className={Style.header}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                <div>
                                    <h4 style={{ fontSize: 14, fontWeight: 600, color: "#052f35 " }}>Data Model</h4>
                                    <h5 style={{ color: "#9D9D9D", fontWeight: 400, fontSize: 13 }}>View or create a data model</h5>
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {
                                        apiResponse.length !== 0 && 
                                        <div>
                                            <Input
                                                className="dm-search"
                                                style={{ width: 375, height: 36, marginRight: 15 }}
                                                prefix={<SearchIcon style={{ paddingRight: 4 }} />}
                                                placeholder="Search"
                                                value={inputValue}
                                                onChange={handleChange}
                                            />
                                            {canCreateDM && <Button
                                                style={{ width: 100, height: 36, borderRadius: 4, borderColor: "#052f35 ", backgroundColor: "#052f35 ", border: "1px solid #052f35 " }}
                                                onClick={() => { setAddNew(true) }}
                                            >
                                                <span style={{ color: "#FFFFFF", fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "center", fontStyle: "normal", fontSize: 13 }}>Add Column</span>
                                            </Button>}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div style={{ width: "100%", marginTop: 20, display: "flex", alignItems: "center", justifyContent: "center" }} className={"row " + Style.Table}>
                            {(!addNew && apiResponse.length == 0) ?
                                (isLoading ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', width: '100%' }}>
                                        <div>
                                            <Spin  indicator={
                                                <Icon type="loading" style={{ fontSize: 30, color: '#15808C' }} spin />
                                            } />
                                            <p>Loading...</p>
                                        </div>
                                    </div> :
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingTop: 100 }}>
                                        <NOData></NOData>
                                        <div style={{ color: "#052f35 ", fontSize: 14, marginTop: 17, fontWeight: 600 }}>Create a Data Model</div>
                                        <div style={{ color: "#9D9D9D", fontSize: 13, marginTop: 10, fontWeight: 400 }}>Begin by adding columns to create the Data Model</div>
                                        {canCreateDM && <Button
                                            style={{ width: 100, height: 36, borderRadius: 4, borderColor: "#052f35 ", backgroundColor: "#052f35 ", border: "1px solid #052f35 ", marginTop: 20 }}
                                            onClick={() => { setAddNew(true) }}
                                        >
                                            <span style={{ color: "#FFFFFF", fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "center", fontStyle: "normal", fontSize: 13 }}>Add Column</span>
                                        </Button>}
                                    </div>
                                ) : (
                                    <Table
                                        data-test-id="table_row"
                                        columns={columns}
                                        pagination={false}
                                        scroll={{ y: 'calc(100vh - 225px)' }}
                                        onRow={(record) => ({
                                            'data-test-id': record,
                                            onMouseEnter: () => setHoveredRow(record),
                                            onMouseLeave: () => setHoveredRow(null),
                                        })}
                                        className={"dm-table-container"}
                                        style={{ width: '100%', display: "flex", alignItems: "center", justifyContent: "space-evenly" }}
                                        dataSource={!addNew ? filteredData : [...newData, ...filteredData]}
                                    />
                                )}
                        </div>
                    </div>
                    {deleteModalVisible &&
                        <Modal
                            className="dm-delete-modal"
                            visible={deleteModalVisible}
                            title="Confirmation"
                            closeIcon={<CloseButton />}
                            onCancel={() => setDeleteModalVisible(false)}
                            footer={[
                                <span style={{ color: "#95ABD3", fontSize: 13, paddingRight: 53, cursor: "pointer", fontWeight: 600 }} key="cancel" onClick={() => setDeleteModalVisible(false)}>
                                    CANCEL
                                </span>,
                                <Button style={{ backgroundColor: "#FF4F4F", color: "#FFFFFF", fontSize: 14, height: 40, width: 130, border: "none", borderRadius: 6 }} key="submit" type="primary" onClick={() => deleteData()}>
                                    REMOVE
                                </Button>,
                            ]}>
                            <div
                                key={deleteKey}
                                style={{ display: "flex", padding: "0px 10px", flexWrap: "wrap", maxWidth: "100%", wordBreak: "break-word", fontSize: 14, fontWeight: 400 }}>
                                <div style={{ whiteSpace: "nowrap" }}>Do you want to remove</div>
                                <div style={{ color: "#292D32", padding: "0px 5px", fontWeight: 700, wordBreak: "break-word" }}>
                                    {deleteColumnName}
                                </div>
                                <div style={{ whiteSpace: "nowrap" }}>from Data Model?</div>
                            </div>
                        </Modal>}
                </div> : <div className='viewWrapper'>
                    <NoData
                        svg={WarningIcon}
                        header='Not Authorized'
                        content='Please request owner of this organization to provide access'
                        noButton={true}
                    />
                </div>}
        </>
    )
}
